import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private apiService: ApiService
  ) {

  }

  fetchConnections() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '?status=accepted');
  }

  fetchConnectionsPerPage(MyConnections) {
    let params = "?page=" + MyConnections + "&status=accepted";
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + params);
  }

  fetchOnlineConnections(onlineConnectionPage) {
    let params = "/online?" + 'page=' + onlineConnectionPage + "&status=accepted";
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + params);
  }

  shareInvite(param) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SHARE_INVITE, param);
  }

  fetchSpecificUserConnection(userId) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_CONNECTION + '?status=accepted&id=' + userId);
  }
  fetchSettingBasedConnection(userId, page, searchText) {
    let params = '?page=' + page + '&id=' + userId;
    if (searchText) {
      params += '&search=' + searchText;
    }
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SETTING_BASED_CONNECTION + params);
  }
  fetchSubscriptionSearch(userId, page, searchText) {
    let params = '?page=' + page + '&id=' + userId;
    if (searchText) {
      params += '&search=' + searchText;
    }
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIBERS + '/get_all_subscribers' + params);
  }
  deleteConnection(userId) {
    return this.apiService.delete(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + userId);
  }

  loadUserCategory() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USER_CATEGORY);
  }

  loadIndustryType() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.INDUSTRIES);
  }

  loadBusinessType() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.BUSINESS);
  }

  blockConnection(userId, param) {
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + userId, param);
  }


  /**
   * Block users : block not connected users
   *
   * @param {*} param
   * @returns
   * @memberof ProfileService
   */
  blockUserAndContent(param) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.BLOCK_USERS_AND_CONETENT, param);
  }

  muteUnmuteConnection(userId, params) {
    return this.apiService.patch(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + userId, params);
  }

  fetchSuggestedConnections() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + API_ENDPOINTS.API.SUGGESTED_CONNECTIONS);
  }

  fetchAllRequestConnections() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '?status=pending');
  }

  getCities(searchText) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.LOCATIONS + API_ENDPOINTS.API.SEARCH + '?city=' + searchText);
  }

  getCountries(searchText) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.LOCATIONS + API_ENDPOINTS.API.SEARCH + '?country=' + searchText);
  }
  getAllCountries() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.LOCATIONS + API_ENDPOINTS.API.SEARCH + '?country');
  }

  reportConnection(connectionId, param) {
    const formData = new FormData();
    Object.entries(param).forEach(([key, value]) => {
      if (key == 'reason' && param['reason']) {
        Object.entries(param['reason']).forEach(([k, v]) => {
          formData.append(`report_connections[${key}][]`, v.toString() as string);
        });
      } else {
        formData.append(`report_connections[${key}]`, value as string);
      }
    })
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONNECTIONS + '/' + connectionId + API_ENDPOINTS.API.REPORT_CONNECTION, formData);
  }

  reportContent(param) {
    // const formData = new FormData();
    // Object.entries(param).forEach(([key, value]) => {
    //   if (key == 'reason' && param['reason']) {
    //     Object.entries(param['reason']).forEach(([k, v]) => {
    //       formData.append(`report_connections[${key}][]`, v.toString() as string);
    //     });
    //   }else{
    //     formData.append(`report_connections[${key}]`, value as string);
    //   }
    // })
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTENTS + API_ENDPOINTS.API.REPORT_CONTENT, param);
  }

  fetchRecentActivities() {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.RECENT_ACTIVITY);
  }

  fetchNotifications(param) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.NOTIFICATIONS + '?' + param);
  }

  markhNotifications(param) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.NOTIFICATIONS + '/' + param);
  }

  fetUserPublishesCount(userId) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + API_ENDPOINTS.API.PUBLISHES_COUNT + '?id=' + userId);
  }

  requestVerification(params) {
    let formData = new FormData();

    Object.entries(params).forEach(([key, value]) => {
      formData.set(`verification[${key}]`, value as string);
    });

    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.BUSINESS_PROFILE + API_ENDPOINTS.API.USER_REQUEST_VERIFICATION, formData);
  }

  submitContactUs(params) {
    let formData = new FormData();

    Object.entries(params).forEach(([key, value]) => {
      formData.set(`contact[${key}]`, value as string);
    });

    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.CONTACTS, formData);
  }

  profileSubscribe(data) {
    return this.apiService.post(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIBERS, data);
  }

  profileUnsubscribe(params, user_id) {
    let formData = new FormData();
    formData.set(`subscriber[status]`, params as string);
    return this.apiService.put(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIBERS + '/' + user_id, formData);
  }

  fetchVerificationTypes(userType) {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.BUSINESS_PROFILE + API_ENDPOINTS.API.GET_VERIFICATION_PROOFS + '?user_type=' + userType);
  }

  fetchSubscribers(params = '') {
    return this.apiService.get(
      API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIBERS + params);
  }

  fetchAdvertisement() {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SCRIPTDOOR_ADVERTISEMENT + API_ENDPOINTS.API.FETCH_ADVERTISEMENT);
  }

  upgradeSubscription(subscriptionId) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIBERS + '/' + subscriptionId + API_ENDPOINTS.API.UPGRADE_LIBRARY_SUBSCRIPTION);
  }

  getUserLibraryPrice(id) {
    http://localhost:3001/v1/users/257/user_profile_settings/get_library_price
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.USERS + '/' + id + API_ENDPOINTS.API.PROFILE_SETTINGS + API_ENDPOINTS.API.GET_LIBRARY_PRICE);
  }
  updateUserAutoRenewal(id) {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIBERS + '/' + id + API_ENDPOINTS.API.UPDATE_AUTO_RENEW);
  }

  fetchPlanCardDetails() {
    return this.apiService.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.VERSION + API_ENDPOINTS.API.SUBSCRIPTIONS + API_ENDPOINTS.API.PLAN_CARD_TEXT);
  }

}
